require ("..\\bootstrap\\js\\dist\\button");
require ("..\\bootstrap\\js\\dist\\carousel");
require ("..\\bootstrap\\js\\dist\\collapse");
require ("..\\bootstrap\\js\\dist\\dropdown");
require ("..\\bootstrap\\js\\dist\\modal");
require ("..\\bootstrap\\js\\dist\\tab");
